import classNames from 'classnames'
import './VerifyInput.scss'

export const VerifyInput = defineComponent({
  props: {
    count: {
      type: Number,
      default: 6,
    },
    modelValue: {
      type: String,
      default: '',
    },
    isPassword: {
      type: Boolean,
      default: false,
    },
    onInputComplete: {
      type: Function,
      default: null as unknown as PropType<null | (() => void)>,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const focusIndex = ref(0)
    const verifyCode = ref('')
    const inputRef = ref<HTMLInputElement>()

    watchEffect(() => {
      const index = verifyCode.value.length
      if (index < 0) {
        focusIndex.value = 0
      } else {
        focusIndex.value = index
      }
      if (index === props.count) {
        inputRef.value?.blur()
      }
      emit('update:modelValue', verifyCode.value)
    })

    const onInputFocus = () => {
      const index = (focusIndex.value = verifyCode.value.length - 1)
      if (index < 0) {
        focusIndex.value = 0
      } else {
        focusIndex.value = index
      }
    }

    const onInput = (e: Event) => {
      const input = e.target as HTMLInputElement
      const value = input.value.replace(/\D/g, '')
      verifyCode.value = value
    }

    const onInputBlur = () => {
      focusIndex.value = -1
    }

    onMounted(() => {
      nextTick(() => {
        if (inputRef.value) {
          Promise.resolve().then(() => {
            inputRef.value?.focus()
          })
        }
      })
    })

    watch(
      () => props.modelValue,
      (value) => {
        if (!value) {
          focusIndex.value = 0
          verifyCode.value = ''
          inputRef.value?.focus()
        }
      },
    )

    watch(
      () => verifyCode.value,
      (code) => {
        if (code.length === props.count) {
          props.onInputComplete?.()
        }
      },
    )

    return () => {
      return (
        <div class="verify-input-layout">
          {Array.from({ length: props.count }).map((_, index) => {
            return (
              <div
                class={classNames('num-item', {
                  focus: focusIndex.value === index,
                  'has-value': !!verifyCode.value[index],
                })}
                key={index}
              >
                <span>{props.isPassword && verifyCode.value[index] ? '•' : verifyCode.value[index]}</span>
                <div class="cursor"></div>
              </div>
            )
          })}
          <input
            ref={inputRef}
            v-model={verifyCode.value}
            class={'input'}
            type={props.isPassword ? 'new-password' : 'text'}
            onFocus={onInputFocus}
            onInput={onInput}
            onBlur={onInputBlur}
          />
        </div>
      )
    }
  },
})

export const TradePasswordInput = VerifyInput
